module.exports = __webpack_public_path__ + "img/dance.e5d6f779.webp";